import { FC, Fragment, useState } from 'react'
import {
  StyleCreateIconWrapper,
  StyleInputWrapper,
  StyleSelectedItems,
  StyleSelectedItem,
} from './style'
import Typography from '@components/typography'
import Column from '@components/column'
import Row from '@components/row'
import Svg from '@components/svg'
import ChooseCategories from '../popups/categories'
interface ChooseSpecializationsProps {
  onChange?: (item: any) => void
  selectedItems?: []
  isError?: boolean
  disabled?: boolean
  hasLabel?: boolean
}
const ChooseSpecializations: FC<ChooseSpecializationsProps> = ({
  selectedItems,
  onChange,
  isError,
  disabled,
  hasLabel = true,
}) => {
  const [visible, setVisible] = useState<boolean>(false)
  return (
    <Fragment>
      <Column rowGap={10} styleColumn="min-width:0px;">
        {!!hasLabel && (
          <Typography
            content="Specialization"
            variant="label"
            size={14}
            tc={!!isError ? 'danger' : 'text'}
          />
        )}
        <StyleInputWrapper isError={!!isError}>
          <Row
            justifyContent="space-between"
            styleRow="padding: 0px 10px;height:100%"
            alignItems="center"
            colGap={5}
          >
            {!!selectedItems?.length && selectedItems?.length >= 3 ? (
              <StyleSelectedItems>
                {selectedItems?.map((selected: any) => {
                  return (
                    <StyleSelectedItem bg={'secondary'} key={selected?.id}>
                      <Typography
                        content={selected?.name}
                        size={12}
                        tc={'white'}
                      />
                    </StyleSelectedItem>
                  )
                })}
              </StyleSelectedItems>
            ) : (
              <StyleSelectedItems>
                {Array(3)
                  ?.fill(0)
                  ?.map((_: any, index: number) => {
                    return (
                      <Fragment key={index}>
                        <StyleSelectedItem
                          bg={!!selectedItems?.[index] ? 'secondary' : 'white'}
                        >
                          {!!selectedItems?.[index] ? (
                            <Typography
                              content={selectedItems[index]['name']}
                              size={12}
                              tc={!!selectedItems?.[index] ? 'white' : 'text'}
                            />
                          ) : (
                            <>
                              <Svg svg="plusHeart" />
                              <Typography size={12} content="Specialty" />
                            </>
                          )}
                        </StyleSelectedItem>
                      </Fragment>
                    )
                  })}
              </StyleSelectedItems>
            )}

            {!disabled && (
              <StyleCreateIconWrapper
                onClick={() => {
                  !disabled && setVisible(true)
                }}
              >
                <Svg svg="circlePlus" />
              </StyleCreateIconWrapper>
            )}
          </Row>
        </StyleInputWrapper>
      </Column>
      <ChooseCategories
        selectedItems={selectedItems}
        visible={visible}
        setVisible={setVisible}
        selector="specializations"
        title="Specialization"
        type="Specialization"
        onClick={(item) => {
          onChange(item)
        }}
      />
    </Fragment>
  )
}

export default ChooseSpecializations
